import React, { useEffect, useRef, useState } from 'react'
import CustomerModel from './models/CustomerModel';
import FileUploadModal from '../../shared/file-upload/FileUploadModal';
import FileList from '../../shared/file-upload/FileList';
import { FILE_UPLOAD_CATEGORIES } from '../../shared/file-upload/fileUploadCategories';

function AddCustomer({ sendDataToParent, onLoad, isOpen }) {
  const [residentialAddress, setResidentialAddress] = useState({});
  const [officeAddress, setOfficeAddress] = useState({});
  const [pendingFiles, setPendingFiles] = useState([]);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const lastPendingFilesRef = useRef(null);

  function handleChange(e) {
    const { name, value } = e.currentTarget;
    sendDataToParent((prevState) => ({
      ...prevState,
      [name]: value,
      ...residentialAddress,
      ...officeAddress,
    }));
  }

  function handleResidentialChange(e) {
    const { name, value } = e.currentTarget;
    setResidentialAddress((prev) => {
      const updated = { ...prev, [name]: value };
      sendDataToParent((prevState) => ({
        ...prevState,
        ...updated,
      }));
      return updated;
    });
  }

  function handleOfficeChange(e) {
    const { name, value } = e.currentTarget;
    setOfficeAddress((prev) => {
      const updated = { ...prev, [name]: value };
      sendDataToParent((prevState) => ({
        ...prevState,
        ...updated,
      }));
      return updated;
    });
  }

  const handleUploadConfirm = ({ category, files, title }) => {
    const additions = (files || []).map((file, idx) => ({
      key: `pending-${Date.now()}-${idx}`,
      OriginalName: file.name,
      FileTitle: title || '',
      FileCategory: category,
      FileSizeKB: Math.max(1, Math.round(file.size / 1024)),
      file,
      status: 'Pending upload'
    }));
    setPendingFiles((prev) => [...prev, ...additions]);
  };

  const handleRemovePending = (file) => {
    setPendingFiles((prev) => prev.filter((f) => f.key !== file.key));
  };

  useEffect(() => {
    onLoad(new CustomerModel());
  }, []);

  useEffect(() => {
    if (!isOpen) {
      setPendingFiles([]);
      setResidentialAddress({});
      setOfficeAddress({});
    }
  }, [isOpen]);

  useEffect(() => {
    if (!sendDataToParent) return;
    if (lastPendingFilesRef.current === pendingFiles) return;
    lastPendingFilesRef.current = pendingFiles;
    sendDataToParent((prev) => ({ ...prev, PendingFiles: pendingFiles }));
  }, [pendingFiles]);

  return (
    <>

      <div className="row">
        <div className="col-lg-8 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Customer Name<span style={{ color: "red" }}>*</span>
          </label>
          <input
            type="text"
            className="form-control"
            name="CustomerName"
            onChange={handleChange}
          />
        </div>

        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Occupation</label>
          <input
            type="text"
            className="form-control"
            name="Occupation"
            onChange={handleChange}
          />
        </div>

         <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Mobile No
          </label>
          <input
            type="text"
            className="form-control"
            name="MobileNumber"
            onChange={handleChange}
          />
        </div>

        <div className="col-lg-8 col-sm-6 col-12 mb-3">
          <label className="form-label">
            Email
          </label>
          <input
            type="email"
            className="form-control"
            name="EmailId"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Annual Income</label>
          <input
            type="number"
            className="form-control"
            name="AnualIncome"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="row">
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Family Member Name</label>
          <input
            type="text"
            className="form-control"
            name="FamilyMemberName"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">Family Member Mobile</label>
          <input
            type="text"
            className="form-control"
            name="FamilyMemberMobileNumber"
            onChange={handleChange}
          />
        </div>
        <div className="col-lg-4 col-sm-6 col-12 mb-3">
          <label className="form-label">DOB</label>
          <input
            type="date"
            className="form-control"
            name="DOB"
            onChange={handleChange}
          />
        </div>
      </div>

      <div className="card-body px-0">
        <nav className="nav nav-style-6 nav-pills mb-3 nav-justified d-sm-flex d-block" role="tablist">
          <a className="nav-link active" data-bs-toggle="tab" role="tab" href="#customer-residential" aria-selected="true">
            Residential Address
          </a>
          <a className="nav-link" data-bs-toggle="tab" role="tab" href="#customer-office" aria-selected="false" tabIndex="-1">
            Office Address
          </a>
          <a className="nav-link" data-bs-toggle="tab" role="tab" href="#customer-references" aria-selected="false" tabIndex="-1">
            References
          </a>
        </nav>
        <div className="tab-content">
          <div className="tab-pane text-muted active show" id="customer-residential" role="tabpanel">
            <div className="row">
              <div className="col-lg-4 col-sm-6 col-12 mb-3">
                <label className="form-label">Resi.Address 1</label>
                <textarea
                  className="form-control"
                  name="AddressLine1"
                  rows="1"
                  onChange={handleResidentialChange}
                />
              </div>
              <div className="col-lg-4 col-sm-6 col-12 mb-3">
                <label className="form-label">Resi.Address 2</label>
                <textarea
                  className="form-control"
                  name="AddressLine2"
                  rows="1"
                  onChange={handleResidentialChange}
                />
              </div>
              <div className="col-lg-4 col-sm-6 col-12 mb-3">
                <label className="form-label">Resi.Address 3</label>
                <textarea
                  className="form-control"
                  name="AddressLine3"
                  rows="1"
                  onChange={handleResidentialChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  name="City"
                  onChange={handleResidentialChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  name="State"
                  onChange={handleResidentialChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  name="Country"
                  onChange={handleResidentialChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Pin No</label>
                <input
                  type="text"
                  className="form-control"
                  name="PinNumber"
                  onChange={handleResidentialChange}
                />
              </div>
            </div>
          </div>

          <div className="tab-pane text-muted" id="customer-office" role="tabpanel">
            <div className="row">
              <div className="col-lg-4 col-sm-6 col-12 mb-3">
                <label className="form-label">Office.Address 1</label>
                <textarea
                  className="form-control"
                  name="OfficeAddressLine1"
                  rows="1"
                  onChange={handleOfficeChange}
                />
              </div>
              <div className="col-lg-4 col-sm-6 col-12 mb-3">
                <label className="form-label">Office.Address 2</label>
                <textarea
                  className="form-control"
                  name="OfficeAddressLine2"
                  rows="1"
                  onChange={handleOfficeChange}
                />
              </div>
              <div className="col-lg-4 col-sm-6 col-12 mb-3">
                <label className="form-label">Office.Address 3</label>
                <textarea
                  className="form-control"
                  name="OfficeAddressLine3"
                  rows="1"
                  onChange={handleOfficeChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">City</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficeCity"
                  onChange={handleOfficeChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">State</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficeState"
                  onChange={handleOfficeChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Country</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficeCountry"
                  onChange={handleOfficeChange}
                />
              </div>
              <div className="col-lg-3 col-sm-6 col-12 mb-3">
                <label className="form-label">Pin No</label>
                <input
                  type="text"
                  className="form-control"
                  name="OfficePinNumber"
                  onChange={handleOfficeChange}
                />
              </div>
            </div>
          </div>

          <div className="tab-pane text-muted" id="customer-references" role="tabpanel">
            <div className="row">
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 1 Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference1Name"
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 1 Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference1MobileNumber"
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 2 Name</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference2Name"
                  onChange={handleChange}
                />
              </div>
              <div className="col-lg-6 col-sm-6 col-12 mb-3">
                <label className="form-label">Reference 2 Mobile</label>
                <input
                  type="text"
                  className="form-control"
                  name="Reference2MobileNumber"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="d-flex justify-content-between align-items-center mb-2">
        <h6 className="mb-0">Attachments</h6>
        <button type="button" className="btn btn-sm btn-outline-primary" onClick={() => setShowUploadModal(true)}>
          Upload Files
        </button>
      </div>
      <FileList files={pendingFiles} showRemove={true} showDownload={false} onRemove={handleRemovePending} />

      <FileUploadModal
        show={showUploadModal}
        onClose={() => setShowUploadModal(false)}
        categories={FILE_UPLOAD_CATEGORIES.customer}
        onConfirm={handleUploadConfirm}
      />
    </>
  )
}

export default AddCustomer